
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 255.69 255.69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('circle',{attrs:{"cx":"127.84","cy":"127.84","r":"127.84","fill":"#1e1e1e"}}),_c('path',{attrs:{"d":"M160.88 112.08V78.23l-33.23-19.86L94.81 78v34.23l-31.64 17V169l33.75 19.21 30.92-17.89 30.93 17.89L192.52 169v-39.52zM72 163.59v-24.08l20.55 12.06v23.82zM123.45 139v23.48l-22.14 12.92v-23.79zm-19.84-26.89V88.28l19.65 12v23zm15.14 19.21l-21.82 12.43L76.83 132l22.34-11.83zm28.72-50.48l-19.79 11.61L108.3 80.6l19.34-11.83zm4.61 7.74v23.72l-20 11v-23zm6.72 55.2l-21.74-12.68 19.62-11L179 132.15zm4.38 31.64V151.6l20.54-11.79v23.78zm-8.8-23.81v23.79l-22.14-12.93v-23.8z","fill":"#fff"}})])])])
          )
        }
      }
    